import {
    ApplicationConfig,
    ErrorHandler,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {httpInterceptorProviders} from '@iw-shop/core/constants/http-intercepter-providers';
import {routes} from '@shop_allgaeu-brennerei_de/app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AppInitConfigService} from "@iw-shop/core/services/app-init-config.service";
import {AppInitConfigDbService} from "@iw-shop/core/services/app-init-config-db.service";
import {AppInitStorageService} from "@iw-shop/core/services/app-init-storage.service";
import {AppInitGlobalService} from "@iw-shop/core/services/app-init-global.service";
import {GlobalErrorHandler} from "@iw-shop/core/classes/error-handler";
import {HTTPQueue} from "@iw-shop/core/classes/http-queue";

import {MetaReducer, provideStore} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {appReducers} from '@store/reducers/app.reducers'; // Replace this with your actual path
import {ShoppingCartEffects} from '@store/effects/shopping-cart.effects';
import {AuthenticationEffects} from '@store/effects/authentication.effects';
import {StorageEffects} from '@store/effects/storage.effects';
import {UserEffects} from '@store/effects/user.effects';
import {environment} from '@environments/environment';

import {localStorageSyncReducer} from "@iw-shop/core/functions/ngrx-local-storage-sync";
import {
    provideTranslateService,
} from "@ngx-translate/core";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import Aura from "@primeuix/themes/aura";
import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";


const metaReducers: MetaReducer<any>[] = [];

// Add `localStorageSyncReducer` only if running in the browser
if (typeof window !== 'undefined') {
    metaReducers.push(localStorageSyncReducer);
}

registerLocaleData(localeDe, 'de-DE');

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({eventCoalescing: true}),


        provideHttpClient(),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/assets/i18n/',
                suffix: '.json'
            }),
            fallbackLang: 'de',
            lang: 'de'
        }),
        provideRouter(routes), provideClientHydration(withEventReplay()),

        provideHttpClient(withInterceptorsFromDi()),
        // Http interceptors
        httpInterceptorProviders,
        // HTTP queue support
        {provide: HTTPQueue},
        // NgRx StoreModule configuration
        provideStore(
            appReducers, // Reducer map for the global application state
            {
                metaReducers, // Provide additional meta-reducers for custom processing
                runtimeChecks: {
                    strictStateImmutability: true, // Ensure state objects are immutable
                    strictActionImmutability: true, // Ensure actions are not mutated
                    strictStateSerializability: true, // Validate that state is serializable
                    strictActionSerializability: true, // Validate that actions are serializable
                },
            }
        ),

        // NgRx EffectsModule configuration
        provideEffects([
            ShoppingCartEffects,
            AuthenticationEffects,
            StorageEffects,
            UserEffects,
        ]),
        // NgRx Store DevTools
        ...(environment.production
            ? [] // Do not include devtools in production
            : [provideStoreDevtools({maxAge: 100, trace: true})]),


        // Application initialization
        provideAppInitializer(async () => {
            const configService = inject(AppInitConfigService);
            const configDbService = inject(AppInitConfigDbService);
            const appInitStorage = inject(AppInitStorageService);
            const appInitGlobal = inject(AppInitGlobalService);

            try {
                await configService.init();
                await configDbService.init();
                await appInitStorage.init();
                await appInitGlobal.init();
            } catch (error) {
                console.error('Initialization of init services failed: ', error);
                throw error;
            }
        }),

        // Error handling
        {provide: ErrorHandler, useClass: GlobalErrorHandler},

        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Aura
            }
        })


    ]
};
